import { Buffer } from 'buffer';
import { Linking } from 'react-native';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from '../../Config';
import UrlParameterHelper from '../../Helper/UrlParameter';

import type { BaseQueryInterceptorType } from './types';

const baseQueryInterceptor: BaseQueryInterceptorType = async (
  args,
  api,
  extraOptions,
) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: config.ROOT_API,
    prepareHeaders: async (headers, { endpoint }) => {
      const initialUrl = await Linking.getInitialURL();
      const token = initialUrl
        ? UrlParameterHelper.getUrlParameter(initialUrl)?.token
        : '';
      headers.set('Accept', 'application/json');
      if (endpoint !== 'logout') {
        headers.set('Content-Type', 'application/json');
      }
      if (endpoint === 'getEventDetails' && token) {
        headers.set(
          'Authorization',
          Buffer.from(token, 'base64').toString('utf8'),
        );
      }
      return headers;
    },
    credentials: 'include', //For setting the cookie include in every request
  });

  try {
    return await baseQuery(args, api, extraOptions);
  } catch (error: any) {
    throw error;
  }
};

export const METHODS = {
  // add as needed
  DELETE: 'DELETE',
  GET: 'GET',
  PATCH: 'PATCH',
  POST: 'POST',
  PUT: 'PUT',
};

export const baseApi = createApi({
  baseQuery: baseQueryInterceptor,
  endpoints: () => ({}),
  reducerPath: 'baseApi',
});
